import moment from "moment";
import syncStorage from "./syncStorage";

export const IS_DEV = process.env.NODE_ENV !== "production";

export const IS_DEV_ENV = process.env.NODE_ENV === "development" || /devapp/.exec(window.location.href);

export function devLog(message, ...optionalParams) {
    if (IS_DEV) {
        //console.log(message, ...optionalParams);
    }
}

export const UKZones = [
    ...moment.tz.zonesForCountry("GB"),
    ...moment.tz.zonesForCountry("IE"),
    ...moment.tz.zonesForCountry("DE"),
    ...moment.tz.zonesForCountry("GR"),
    ...moment.tz.zonesForCountry("RU"),
    ...moment.tz.zonesForCountry("TR"),
    ...moment.tz.zonesForCountry("BY"),
    ...moment.tz.zonesForCountry("NL"),
];

export const UKCountries = ["GB", "IE", "DE", "GR", "RU", "TR", "BY", "NL"];
export const UKCountryCode = navigator.language.split('-')[1];

export const devUrl = "https://devapp.dspworkplace.com";
export const onboarding = "https://onboardingui.dspworkplace.com";
export const ukUrl = "https://app.dspworkplace.co.uk";
export const usUrl = "https://app.dspworkplace.com";
export const prodUrl =
    UKCountries?.includes(UKCountryCode) || UKZones.includes(moment.tz.guess(true))
        ? ukUrl
        : usUrl;

export const baseUrl = prodUrl;

// production s3 upload url
export const S3UploadURL_US = "https://qlrcua7vhg.execute-api.us-east-2.amazonaws.com/default/mediaUpload";

// onbording s3url
export const S3UploadURL_ONBOARDING = "https://29mxw2zse7.execute-api.us-east-1.amazonaws.com/default/mediaUpload";

// uk s3url
export const S3UploadURL_UK = "https://7vgwef8wbg.execute-api.eu-west-2.amazonaws.com/default/mediaUpload";

const isUKTimezone = async (timezone) => {
    return UKZones.includes(timezone);
};

const isUKCountry = async () => {
    const UKCountryCode = navigator.language.split('-')[1];
    return UKCountries.includes(UKCountryCode);
};

export const isUKApp = async () => {
    const [isCountryUK, isTimezoneUK] = await Promise.all([isUKCountry(), isUKTimezone(moment.tz.guess(true))]);
    return isCountryUK || isTimezoneUK;
};

export const getS3UploadURL = async () => {
    const isOnboard = isOnboarding();
    const isUk = await isUKApp();
    if (isUk) {
        return S3UploadURL_UK;
    } else if (isOnboard) {
        return S3UploadURL_ONBOARDING;
    }
    return S3UploadURL_US;
};

export const isOnboarding = () => {
    try {
        if (window.location.href?.includes("onboardingui")) {
            return true;
        } else if (baseUrl.includes("onboardingui")) {
            return true;
        } else return false;
    } catch (e) {
        return false;
    }
}

export const isDev = () => {
    try {
        if (window.location.href?.includes("localhost") || window.location.href?.includes("devapp")) {
            return true;
        } else if (baseUrl.includes("localhost") || baseUrl.includes("devapp")) {
            return true;
        } else return false;
    } catch (e) {
        return false;
    }
};

export const S3Bucket = (UKCountries?.includes(UKCountryCode) || UKZones.includes(moment.tz.guess(true))) ? 'dsp.data.storage.uk' : 'dsp.data.storage.general';

const isUKRegion =
  UKCountries?.includes(UKCountryCode) ||
  UKZones.includes(moment.tz.guess(true));

export const S3Region = isUKRegion
  ? "us-west-2"
  : isOnboarding()
  ? "us-east-1"
  : "us-east-2";

export const country = (UKCountries?.includes(UKCountryCode) || UKZones.includes(moment.tz.guess(true))) ? 'UK' : 'US';

export const getRealmDeviceObject = () => {
    return {
        id: syncStorage.get("deviceId"),
        number: syncStorage.get("devicePhoneNumber"),
        model: syncStorage.get("deviceModel"),
        manufacturer: syncStorage.get("deviceVendor"),
        osVersion: syncStorage.get("osVersion"),
        platform: syncStorage.get("platform"),
        deviceId: syncStorage.get("deviceId"),
        deviceUid: syncStorage.get("deviceUID"),
        isPersonalDevice: false,
        isOwned: false,
        isPending: false,
    };
};

export const googleMapsApiKey = "AIzaSyAS5ZL-EkYYKUHqlzQJneR5YfKrrCnXobA";

// Convert HEX to RGB
export const hexToRgb = (hex) => {
    if (typeof hex !== 'string') return null
    const normalizedHex = hex.trim()
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    const expandedHex = normalizedHex.replace(
        shorthandRegex,
        function (m, r, g, b) {
            return r + r + g + g + b + b
        }
    )

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(expandedHex)

    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        }
        : null
}

// Calculate luminance
export const luminance = ({ r, g, b }) => {
    const a = [r, g, b].map((v) => {
        v /= 255
        return v <= 0.03928
            ? v / 12.92
            : Math.pow(
                (v + 0.055) / 1.055,
                2.4
            )
    })

    return (
        a[0] * 0.2126 +
        a[1] * 0.7152 +
        a[2] * 0.0722
    )
}

// Check contrast
export const calculateContrast = (
    background = '#000000',
    text = '#ffffff'
) => {

    const color1luminance = luminance(hexToRgb(background))

    const color2luminance = luminance(hexToRgb(text))

    const ratio =
        color1luminance > color2luminance
            ? (
                (color2luminance + 0.05) /
                (color1luminance + 0.05)
            )
            : (
                (color1luminance + 0.05) /
                (color2luminance + 0.05)
            )

    return ratio < (1 / 4.5)
}